// Your existing sliderUtils function
export function sliderUtils() {

}
